// Locations
export const RequestedLocationCountDefault = 10;
export const MinLocationCount = 4;
export const MaxLocationCount = 10;

// Adventures
export const RequestedAdventuresCountDefault = 3;
export const MinAdventureCount = 2;
export const MaxAdventureCount = 4;

// Collab Summary
export const DaysCreatorsHaveToApply = 7
export const DaysToChooseCreator = 10;

// Choose creator date constants
export const ChooseCreatorRecommendedDaysLimit = 8;
export const ChooseCreatorDaysLimitWithoutWarning = 14;